


























/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";

import axios from "axios";
import { IIssueService } from "../../../BusinessServices/issue";
import { IssueModel, BlobReplaceDTO, IssueFolioModel } from "../../../Generated/ParticaAPI";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";


@Component(
	{
		name: "IssueFolio",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
		}
	})
export default class IssueFolio extends ParticaIssueBase {
	@Prop() private id: number;
	private issueService: IIssueService;
	private issue: IssueModel = new IssueModel();
	private issueFolio: IssueFolioModel = new IssueFolioModel();
	private folio: string = "";

	private buttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.ISSUE_SAVE_FOLIO, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Clear", action: eParticaAction.ISSUE_CLEAR_FOLIO, type: ButtonType.Normal } as ButtonConfig,

	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ISSUE_CLEAR_FOLIO: {
					this.clear();
					break;
				}
				case eParticaAction.ISSUE_SAVE_FOLIO: {
					const folios = this.folio.split(",");
					if (folios.length !== this.issue.numberPages) {
						this.ShowSnackbar(`Incorrect number of folios ${folios.length}. There are ${this.issue.numberPages} pages in this issue.`);
					} else {
						this.issueFolio = await this.issueService.SaveFolio(this.id, this.folio);
						this.ShowSnackbar("Folio saved.");
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Issue Folio";
		await this.init();
		await this.getIssueNav(this.id);
	}

	private clear() {
		this.folio = "";
		if (this.issue.numberPages !== undefined) {
			for (let i: number = 0; i < this.issue.numberPages - 1; i++) {
				this.folio += `${i + 1},`;
			}
			this.folio += `${this.issue.numberPages}`;
		}
	}

	private async init() {
		try {
			this.LoadingStart();
			this.issueService = this.particaServices.getIssueService();
			this.issue = await this.issueService.getIssue(this.id);
			this.issueFolio = await this.issueService.LoadFolio(this.id);
			if (this.issueFolio.issueid === undefined) {
				this.clear();
				this.ShowSnackbar("There is no folio for this issue. Click 'SAVE' to store this generated one.");
			} else {
				this.folio = this.issueFolio.folio as string;
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
